import React, {ChangeEvent, KeyboardEvent, Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import Limits from '../Limits';
import InputError, {fieldErrorClass} from '../InputError';
import {depositExchangedAmount, depositP2PExcangedAmount, isoCurrencyToHtml} from '../depositExchangeAmount';
import {inject, observer} from 'mobx-react';
import {DepositsStoreProps} from 'app/store/DepositsStore';
import {getRateByCurrency} from 'app/utils/deposits/getRateByCurrency';
import AmountInput from 'app/components/reusable/AmountInput';

interface DepositAmountProps extends DepositsStoreProps {
    isHiddenForRedirect?: boolean
    name?: string,
    currency?: string
    exchange_currency?: string
}

@inject('depositsStore')
@observer
export default class DepositAmount extends Component<DepositAmountProps> {
    state = {minLimits: ''};

    depositUpdateAmount = (event: KeyboardEvent<HTMLInputElement> | ChangeEvent<HTMLInputElement>): void => {
        const target = event.target as HTMLInputElement;
        const {value} = target;
        this.props.depositsStore.updateAmount(value);
        if (value.length === 0) {
            this.setState({minLimits: ''});
        }
    };

    amount = (): string => {
        const {amount, rates} = this.props.depositsStore;
        const amountOrMinLimits = amount.length > 0 ? amount : this.state.minLimits;
        const validAmount = amountOrMinLimits && Number(amountOrMinLimits) !== 0 && !isNaN(Number(amountOrMinLimits));
        const {currency, exchange_currency} = this.props;
        const exchange = exchange_currency || this.props.depositsStore.currentPaymentSystem.exchange_currency;
        const exchangedAmount = exchange && validAmount ? depositExchangedAmount(amountOrMinLimits, exchange, rates) : '';

        if (currency && currency !== 'USD') {
            const exchangedP2PAmount = validAmount ? depositP2PExcangedAmount(amountOrMinLimits, currency, rates) : '';
            return `${isoCurrencyToHtml(currency)} ${exchangedP2PAmount}`;
        }

        return `$ ${exchangedAmount}`;
    };

    setMinLimits = (minLimits: string): void => this.setState({minLimits});

    render(): ReactNode {
        const {amount, rates, errors: {error}} = this.props.depositsStore;
        const {isHiddenForRedirect, name, currency} = this.props;
        const rate = getRateByCurrency(currency, rates);
        const amountOrMinLimits = amount.length > 0 ? amount : this.state.minLimits;
        return <div className="form__row">
            <div className="form__row-item">
                <label className="form__row-label">
                    {I18n.t('amount')}, {this.amount()}
                </label>
                <div className={fieldErrorClass(Boolean(error))}>
                    <AmountInput
                        containerClassName="field__wrap"
                        id="deposit_amount"
                        name={isHiddenForRedirect ? null : name || 'amount'}
                        className="field__input"
                        maxLength={7}
                        value={amountOrMinLimits}
                        onKeyUp={this.depositUpdateAmount}
                        onChange={this.depositUpdateAmount}
                    >
                        {error && <InputError error={error}/>}
                    </AmountInput>
                </div>

                <Limits currency_rate={rate} currency={rate ? currency : null} setMinLimits={this.setMinLimits}/>
            </div>
        </div>;
    }
}
